import { handleError } from '@anchorage/sentry';
import { isNaN, toNumber } from 'lodash-es';
import numeral from 'numeral';

/**
 * Format a numeric value as a USD-prefixed string. Use `'short'` for
 * abbreviated form ($1.23m), default produces `$1,234.56`.
 *
 * Reports invalid input via Sentry and falls back to `0` so the UI never
 * shows `$NaN`.
 */
export const formatMoney = (
  money: number | string,
  format?: 'long' | 'short',
) => {
  let value = toNumber(money);

  if (isNaN(value) || money === null) {
    value = 0;
    handleError(new Error('formatMoney called with invalid input: ' + money));
  }

  const numeralFormat = format === 'short' ? '$0.00a' : '$0,0.00';
  const formattedAmount = numeral(value).format(numeralFormat);

  if (formattedAmount.replace('$', '') !== 'NaN') {
    return formattedAmount;
  }

  // Numeral returns NaN for very small numbers — fall back to a zero of the
  // same format. https://github.com/adamwdraper/Numeral-js/issues/596
  return numeral(0).format(numeralFormat);
};
